import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledMoreMenu = styled.div`
  position: absolute;
  right: 16px;
  top: -22px;
`;

export const StyledP = styled(P)`
  margin: 0;
`;
